var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessIdSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 6.883,
    viewBox: "0 0 9 6.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Id-Card",
    transform: "translate(-3.25 -6.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143140",
    "data-name": "Path 143140",
    d: "M12.25,7.221a.97.97,0,0,0-.971-.971H4.221a.97.97,0,0,0-.971.971v4.941a.97.97,0,0,0,.971.971h7.059a.97.97,0,0,0,.971-.971Zm-.529,0v4.941a.441.441,0,0,1-.441.441H4.221a.441.441,0,0,1-.441-.441V7.221a.441.441,0,0,1,.441-.441h7.059a.441.441,0,0,1,.441.441Z",
    fill: "#52b33a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143141",
    "data-name": "Path 143141",
    d: "M7.849,19.009a1.039,1.039,0,0,1,1.006-.779h.639a1.039,1.039,0,0,1,1.006.779.24.24,0,0,0,.464-.12,1.518,1.518,0,0,0-1.47-1.138H8.855a1.518,1.518,0,0,0-1.47,1.138.24.24,0,0,0,.464.12Z",
    transform: "translate(-2.562 -7.326)",
    fill: "#52b33a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143142",
    "data-name": "Path 143142",
    d: "M9.768,9.75a1.518,1.518,0,1,0,1.518,1.518A1.519,1.519,0,0,0,9.768,9.75Zm0,.479a1.039,1.039,0,1,1-1.039,1.039A1.039,1.039,0,0,1,9.768,10.229Z",
    transform: "translate(-3.136 -2.154)",
    fill: "#52b33a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143143",
    "data-name": "Path 143143",
    d: "M20.49,11.729h.959a.24.24,0,0,0,0-.479H20.49a.24.24,0,0,0,0,.479Z",
    transform: "translate(-10.879 -3.221)",
    fill: "#52b33a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143144",
    "data-name": "Path 143144",
    d: "M20.49,15.729h.959a.24.24,0,0,0,0-.479H20.49a.24.24,0,0,0,0,.479Z",
    transform: "translate(-10.879 -5.799)",
    fill: "#52b33a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143145",
    "data-name": "Path 143145",
    d: "M20.49,19.729h.639a.24.24,0,0,0,0-.479H20.49a.24.24,0,0,0,0,.479Z",
    transform: "translate(-10.91 -8.376)",
    fill: "#52b33a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIdSvg);
export default __webpack_public_path__ + "static/media/businessIDSvg.1e947b16316e7d527be740fd6c451c01.svg";
export { ForwardRef as ReactComponent };